module.exports = __webpack_public_path__ + "img/w3_reload_light.9d7b70ba.png";